import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

class VideosView extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
  }

  render() {
    const { translate, data } = this.props

    return (
      <div className='padding'>
        <Row className='margin-bottom margin-top'>
          <span className='gray-title'>{translate('analytics.gesttube')}</span>
        </Row>

        <Row className='margin-top-double'>
          <Col xs={8} xsOffset={2}>
            <span className='item-title'>
              {translate('analytics.lastVideo')}
            </span>
          </Col>
        </Row>

        <Row className='margin-top-double'>
          <Col xs={1} xsOffset={4}>
            <i className='view' />
          </Col>
          <Col xs={3}>
            <span className='counter'> {data.nrViews ? data.nrViews : 0} </span>
          </Col>
        </Row>

        <Row className='margin-top-double'>
          <Col xs={1} xsOffset={2}>
            <i className='like' />
          </Col>
          <Col xs={3}>
            <span className='counter'> {data.nrLikes ? data.nrLikes : 0}</span>
          </Col>
          <Col xs={1} xsOffset={1}>
            <i className='dislike' />
          </Col>
          <Col xs={3}>
            <span className='counter'>
              {' '}
              {data.nrDislikes ? data.nrDislikes : 0}
            </span>
          </Col>
        </Row>

        <Row className='margin-top-double filters'>
          <Col xs={2} xsOffset={10}>
            <div className='circular wrap-click' />
          </Col>
        </Row>
      </div>
    )
  }
}

export default VideosView
